import { combineEpics } from 'redux-observable';
import { fetchLotAdjustmentLogsEpic } from '@/store/epics/staff/lot-adjustments-audit-log/fetch-lot-adjustment-logs.epic';

export const combinedLotAdjustmentsLogsEpics = combineEpics(
    fetchLotAdjustmentLogsEpic,
);
